import { Col, Link, Row, Tag } from "@/components";
import { ArrowRight } from "@/icons";
import { AggregationPage } from "@anoki/fse-common/dist";

export type FilterTag = {
  selected: boolean;
  onClick?: () => void;
} & Partial<AggregationPage>;

type Props = {
  title: string;
  showAllLabel?: string;
  showAllHref?: string;
  mainTag: {
    label?: string;
    onClick?: () => void;
    selected?: boolean;
  };
  tags: Array<FilterTag>;
  onTagClick: () => void;
};

export const TagsSection = ({
  title,
  mainTag = {
    label: "Tutto",
    onClick: () => {},
    selected: true,
  },
  tags,
  showAllHref,
  showAllLabel = "Scopri tutti tags",
  onTagClick,
}: Props) => {
  return (
    <Col gap="x28">
      <Row alignItems="center" justifyContent="space-between">
        {title && (
          <h2 className="title text-slate-20 fs-custom fw-bold">{title}</h2>
        )}
        {showAllHref && (
          <Link
            transform="uppercase"
            decoration="fw-semibold text-primary fs-8 mr-x8 text-decoration-none"
            title={showAllLabel}
            src={showAllHref}
            icon={ArrowRight}
          />
        )}
      </Row>

      <Row
        alignItems="center"
        className="overflow-auto w-auto"
        gap="x16"
        flexWrap="wrap"
      >
        {[
          {
            name: mainTag.label,
            selected: mainTag.selected,
            onClick: mainTag.onClick,
          },
          ...tags,
        ].map((tag, index) => (
          <Tag
            key={index}
            mode="filter"
            label={tag.name ?? ""}
            onClick={tag?.onClick ?? onTagClick}
            selected={tag.selected}
          />
        ))}
      </Row>
    </Col>
  );
};
